// class AccordionComponent extends HTMLElement {
//   constructor() {
//     super();
//     this.accordionHeading = this.querySelector('.accordion__heading');
//     this.accordionContent = this.accordionHeading.closest('.accordion__wrap');
//     console.log(this.accordionContent);

//     this.accordionHeading.addEventListener('click', this.toggleAccordion.bind(this));
//   }

//   toggleAccordion() {
//     this.accordionContent.classList.toggle('show-full');
//   }
// }

// customElements.define('accordion-component', AccordionComponent);

$( document ).ready(function() {
  $(document).on("click", ".accordion__heading", function() {
    let accordionWrap = $(this).closest('.accordion__wrap');

    accordionWrap.toggleClass('show-full');
  });
});


// Quantity Product 
const selectors$w = {
  wrapper: '[data-quantity-selector]',
  increase: '[data-increase-quantity]',
  decrease: '[data-decrease-quantity]',
  input: '[data-quantity-input]',
};

class Quantity extends HTMLElement {
  constructor() {
    super();

    this.wrapper = this.querySelector('[data-quantity-selector]');
    this.increase = this.wrapper.querySelector(selectors$w.increase);
    this.decrease = this.wrapper.querySelector(selectors$w.decrease);
    this.input = this.wrapper.querySelector(selectors$w.input);
    this.min = parseInt(this.input.getAttribute('min'), 10);
    this.initButtons();

  }

  initButtons() {
    this.increase.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        let v = parseInt(this.input.value, 10);
        v = isNaN(v) ? 0 : v;
        //console.log(this.input.getAttribute("max_value"));
        let max_value = this.input.getAttribute("max_value")
        if(max_value == null || parseInt(max_value) > v) v++;
        //if(max_value == null) v++;
        this.input.value = v;
        this.input.dispatchEvent(new Event('change'));
      }.bind(this)
    );
    this.decrease.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        let v = parseInt(this.input.value, 10);
        v = isNaN(v) ? 0 : v;
        v--;
        v = Math.max(this.min, v);
        this.input.value = v;
        this.input.dispatchEvent(new Event('change'));
      }.bind(this)
    );
  }
}

customElements.define('quantity-button', Quantity);

/*====== Calculator price ======*/
// Toggle tabs

class ChangeTab extends HTMLElement {
  constructor() {
    super();
    this.navTabs = this.querySelectorAll('.nav__tabs li');
    this.tabsContent = this.querySelectorAll('.tab__pane');

    this.navTabs.forEach( nav => {
      nav.addEventListener('click', this.isActiveTabClick.bind(this));
    })
    
    this.isActiveTabFirstLoad();

  }

  isActiveTabFirstLoad() {
    let currentHash = window.location.hash.slice(1);
    if (window.location.hash != '') {    
      this.navTabs.forEach(nav => {
        if (nav.getAttribute('data-id') == currentHash) {
          nav.classList.add('active');
        }else {
          nav.classList.remove('active');          
        }
      });
  
      this.tabsContent.forEach( tab => {
        if (tab.id == currentHash) {
          tab.classList.add('active');
        }else {
          tab.classList.remove('active');
        }
      });      
    } 

    this.isActiveSecondTab();
  }

  isActiveTabClick(e) {
    this.navTabs.forEach((nav) => {  
      nav.classList.remove('active');      
    });
        
    e.currentTarget.classList.add("active");

    this.tabsContent.forEach( tab => {
      if (tab.id == e.currentTarget.getAttribute('data-id')) {
        tab.classList.add('active');
      }else {
        tab.classList.remove('active');    
      }
    });   
  }

  isActiveSecondTab() {
    let a = false;
    let b = false;
    this.querySelectorAll('li').forEach( elm => {
      if ( elm.className.includes('active') ) {
        a = true; 
      }
    });  

    if (a == false ) {
      this.querySelectorAll('li').forEach( (elm, index) => {
        if (index == 0) {
          elm.classList.add('active');
        }
      });
    }

    this.querySelectorAll('.tab__pane').forEach( elm => {
      if ( elm.className.includes('active') ) {
        b = true; 
      }
    });

    if (b == false ) {
      this.querySelectorAll('.tab__pane').forEach( (elm, index) => {
        if (index == 0) {
          elm.classList.add('active');
        }
      });
    }
   
  }
}

customElements.define('change-tab', ChangeTab);


// Calculator total 

class CalculatorTotal extends HTMLElement {
  constructor() {
    super();
    this.columnInputs = this.querySelectorAll('.column__input[data-calculator]');
    this.columnInputsDiscount = this.querySelectorAll('.column__input[data-calculator-discount]');
    this.columnInputsTotal = this.querySelector('.column__input.total__value');
    this.columnInputsTotalDiscount = this.querySelector('.column__input.total__value_discount');
    const _this = this;

    this.querySelectorAll('.quantity__input').forEach(item => {
      item.addEventListener('change', function(){
        _this.calculatorValue();
      });
    });

    this.querySelectorAll('.input__value').forEach(item => {
      item.addEventListener('change', function(){
        _this.calculatorValue();
      });
    });
  }

  calculatorValue() {
    let total = 0;
    let totalDiscount = 0;
    let totalValue=0;
    const unit = '$';
    const percent = '%'
    
    let membershipMonthly = (this.getAttribute('membership-monthly')) ? parseFloat(this.getAttribute('membership-monthly')) : 650;
    let membershipYearly = (this.getAttribute('membership-yearly')) ? parseFloat(this.getAttribute('membership-yearly')) : 650;
    
    this.columnInputs.forEach( function (input) {
      let quantityInput = input.querySelector('.quantity__input');
      let valueInput = input.querySelector('.unit__value input');
      let totalInput = input.querySelector('.calculated__value input');
      const quantity = parseInt(quantityInput.value);
      const value = parseFloat((valueInput.value).slice(1));
      let totalLineItem = (quantity * value).toFixed(2);
      console.log(totalLineItem);
      totalInput.value = unit.concat(totalLineItem);
      total += parseFloat(totalLineItem);
    });

    this.columnInputsDiscount.forEach( function (input) {
      let priceInput = input.querySelector('.input__value input');
      let valueInput = input.querySelector('.unit__value input');
      let totalInput = input.querySelector('.calculated__value input');
      let price;

      if (priceInput.value.includes('$')) {
        price = parseInt((priceInput.value).slice(1));        
      }else {
        price = parseInt(priceInput.value);  
      }
      let value = valueInput.getAttribute('data-discount-percent');
      let totalLineItem = ( price * value / 100 ).toFixed(2);

      totalInput.value = unit.concat(totalLineItem);
      valueInput.value = unit.concat(price);     

      totalDiscount += parseFloat(totalLineItem);
      total = total + totalDiscount;
    });

    if ( this.getAttribute('data-tab') == 'dogs' ) {     
      let totalSavings = parseFloat(total) - membershipMonthly; 
      let totalSavingsPercent = (totalSavings / total ) * 100;
      let totalSavingsDiscount = parseFloat(total) - membershipYearly; 
      let totalSavingsPercentDiscount = (totalSavingsDiscount / total ) * 100;

      this.columnInputsTotal.querySelector('#total_savings').value = unit.concat(totalSavings.toFixed(2));
      this.columnInputsTotal.querySelector('#savings_percents').value = totalSavingsPercent.toFixed(2).concat(percent);      
      this.columnInputsTotalDiscount.querySelector('#total_savings_discount').value = unit.concat(totalSavingsDiscount.toFixed(2));
      this.columnInputsTotalDiscount.querySelector('#savings_percents_discount').value = totalSavingsPercentDiscount.toFixed(2).concat(percent);
    }

    if ( this.getAttribute('data-tab') == 'cats') {     
      let totalSavings = parseFloat(total) - membershipMonthly; 
      let totalSavingsPercent = (totalSavings / total ) * 100;
      let totalSavingsDiscount = parseFloat(total) - membershipYearly; 
      let totalSavingsPercentDiscount = (totalSavingsDiscount / total ) * 100;

      this.columnInputsTotal.querySelector('#total_savings').value = unit.concat(totalSavings.toFixed(2));
      this.columnInputsTotal.querySelector('#savings_percents').value = totalSavingsPercent.toFixed(2).concat(percent);      
      this.columnInputsTotalDiscount.querySelector('#total_savings_discount').value = unit.concat(totalSavingsDiscount.toFixed(2));
      this.columnInputsTotalDiscount.querySelector('#savings_percents_discount').value = totalSavingsPercentDiscount.toFixed(2).concat(percent);
    }
    

    if ( this.getAttribute('data-tab') == 'dogs-plus' || this.getAttribute('data-tab') == 'cats-plus' 
    || this.getAttribute('data-tab') == 'puppies' || this.getAttribute('data-tab') == 'kittens') {
      /*if (totalDiscount > 0) {
        totalValue = total + totalDiscount;
      }else {
        totalValue = total;
      }*/
      totalValue = total;
      
      let totalSavings = parseFloat(totalValue) - membershipMonthly; 
      let totalSavingsPercent = (totalSavings / totalValue ) * 100;
      let totalSavingsDiscount = parseFloat(totalValue) - membershipYearly; 
      let totalSavingsPercentDiscount = (totalSavingsDiscount / totalValue ) * 100;

      this.columnInputsTotal.querySelector('#total_savings').value = unit.concat(totalSavings.toFixed(2));
      this.columnInputsTotal.querySelector('#savings_percents').value = totalSavingsPercent.toFixed(2).concat(percent);      
      this.columnInputsTotalDiscount.querySelector('#total_savings_discount').value = unit.concat(totalSavingsDiscount.toFixed(2));
      this.columnInputsTotalDiscount.querySelector('#savings_percents_discount').value = totalSavingsPercentDiscount.toFixed(2).concat(percent);
    }

    this.columnInputsTotal.querySelector('#total_value').value = unit.concat(total.toFixed(2));
    this.columnInputsTotalDiscount.querySelector('#total_value').value = unit.concat(total.toFixed(2));
  }

}

customElements.define('calculator-total', CalculatorTotal);


// Equal height on section image galery
class EqualHeight extends HTMLElement {
  constructor() {
    super();
    this.contentBLocks = this.querySelectorAll('.overlay-text');
    if ( document.querySelector('body').offsetWidth > 767) {
      this.equalizeHeight();      
    }
  }

  equalizeHeight() {
    let height = 0;
    this.contentBLocks.forEach(content => {
      if (content.clientHeight > height) {
        height = content.clientHeight;
      }
    });

    this.contentBLocks.forEach(content => {
      content.style.height = `${height}px`;
    });
  }
}

customElements.define('equal-height', EqualHeight);


// Video list 
class VideoItem extends HTMLElement { 
  constructor() {
    super();
    this.videoItem = this.querySelector('.js-video-popup');
    this.buttonOpen = this.querySelector('.js-open-popup');
    this.buttonClose = this.querySelector('.js-close-popup');
    this.overlay = document.querySelector('.video__popup_overlay');

    if (this.videoItem) {
      this.buttonOpen.addEventListener('click', this.openVideoPopup.bind(this));   
      this.buttonClose.addEventListener('click', this.closeVideoPopup.bind(this));  
      this.overlay.addEventListener('click', this.closeVideoPopup.bind(this));  
    }
  }

  openVideoPopup() {
    this.videoItem.style.display = 'block';
    this.overlay.style.display = 'block';
    let styles = `
      overflow: hidden;
      height: 100%;
    `
    document.querySelector('body').style = styles;
  }

  closeVideoPopup() {
    this.videoItem.style.display = 'none';
    this.overlay.style.display = 'none';
    let styles = `
      overflow: unset;
      height: auto;
    `
    document.querySelector('body').style = styles;
  }


}

customElements.define('video-item', VideoItem);

//Added js
jQuery(document).ready(function($){ //wait for the document to load
    $('.product-detail .product-detail__thumbnails').each(function(){ 
        if($(this).height() > 600) { $(this).addClass("overflow") }
    });

   $('.monthly-yearly > div > button').click(function(e){
     e.preventDefault();
     let target = $(this).attr("data-target");
     $(this).parent().parent().find('.check').removeClass('active');
     $(this).find('span').addClass('active');
     $(this).parent().parent().find('.fields > div').hide();
     $(this).parent().parent().find('.fields .'+target).show();
   });

  $(".template-product .payment-buttons > button").click(function(e) {
    let parent = $(this).closest("form").find(".additional-options");
    let error = [];
    parent.find(".text-error").remove();
    parent.find("input").map((i, v) => {
      console.log('the v', $(v).is(":checked"));
      let required = ($(v).attr("required") == "required") ? true : false;
      if(!$(v).is(":checked") && required) {
        error.push("error" + $(v).attr("name"));
        return $(v).parent().prepend( "<span class='text-error'>Missing required field</span>" );
      }
      return; 
    });
    console.log(error);
    if(error.length > 0) return false;
    return true;
  });

  $(".option-selector__btns .opt-label").click(function(e) {
    let weight = $(this).attr('data-weight');
        weight = Number(weight/1000);
    let price = $(this).attr('data-price');
        price = Number(price/100);
    if(!price || !weight) return;
    if(price > 65 && weight < 50)
      $("#free-shipping-tag").css({"display": "inline-block"});
    else
      $("#free-shipping-tag").hide();
    console.log($(this), { price, weight });
  });

  $(".upload-script-option input").click(function(e){
    $(".upload-script-option input").prop('checked', false);
    $(this).prop('checked', true);
    
    $("#prescription-option-file").val($(this).attr('attr-presc'));
    //console.log(pof);

    //disabling and enabling file upload
    if($(this).hasClass("must-upload")) {
      $("#uploadery-container-disable").attr("id","uploadery-container").show();
    } else {
      $("#uploadery-container").attr("id","uploadery-container-disable").hide();
    }

    //disabling and enabling vet practice field
    if($(this).hasClass("must-vet-practice")) {
      $("#vet-practice-name").show();
      //$("#vet-practice-name").find("input").prop('required',true);
    } else {
      $("#vet-practice-name").hide();
      //$("#vet-practice-name").find("input").prop('required',false)
      $("#vet-practice-name").find("input").val("");
    }
  });

  /*$(".ask-experts-form").on("submit", (e) => {
    e.preventDefault();
    const data = $("#contact_form").serializeArray()
    console.log("testing", data); 
    $("#contact_form input[type='submit']").attr('disabled', 'disabled');
    $( "p.response" ).remove();
    //https://yourpetpaapp-uat.azurewebsites.net/v1.2/data/yppa-submit-form
    //https://2e4f-49-145-43-157.ngrok-free.app/v1.2/data/yppa-submit-form
    $.post("https://yourpetpaapp.azurewebsites.net/v1.2/data/yppa-submit-form", data, function(result){
      $("#contact_form input[type='submit']").removeAttr('disabled');
      const response = `<p class="response" style="border: 2px solid;border-radius: 10px;padding: 20px;color: #5bb1b6;">Thank you for submitting a question to our experts. Someone will get back to you within 1 business day.</p>`;
      $("#contact_form").append( response );
    });
  })*/

  $(".click-and-collect li input").click(function(e){
    console.log("CREATE CHECKOUT", $(this).attr('data-cart'));
    const _this = $(this);
    const data = {
      items: $(this).attr("data-cart"),
      address: $(this).attr('data-address'),
      city: $(this).attr('data-city'),
      country: $(this).attr('data-country'),
      province: $(this).attr('data-province'),
      zip: $(this).attr('data-zip'),
      phone: $(this).attr('data-phone'),
    };
    console.log(data);
    e.preventDefault();
    _this.css({"cursor": "wait"});
    //return; https://8e57-49-145-38-208.ngrok-free.app https://yourpetpaapp-uat.azurewebsites.net
    $.post("https://yourpetpaapp-uat.azurewebsites.net/v1.2/data/create-shopify-checkout", data, function(result){
      console.log({ result });
      _this.css({"cursor": "default"});
      const { checkout, checkoutUserErrors } =  result.data.checkoutCreate;
      console.log(result, checkout, checkoutUserErrors);
      if(!checkout)
          return console.log("errors");
      window.location.href = checkout.webUrl;
    });
  })
});